import PropTypes from 'prop-types';
import { useStyles } from '../../../pages/NewOrder/styles';
import { Badge } from '@mui/material';
import MenuItemDetailsDialog from "./MenuItemDetailsDialog";
import React, {useState, useEffect, useContext} from 'react'

export default function MenuItemCard({ item , onClick}) {
    const { name, cover, rate,description, colors, status, priceSale , item_code, projected_qty} = item;
    const classes = useStyles();
    const [detailOpen, setDetailsOpen] = useState(false);


    const handleClick = () => {
        setDetailsOpen(true);
    };

    const handleClose = () => {
        setDetailsOpen(false);
    };


    function truncateDescription(description, maxLength) {
        if (description.length > maxLength) {
            return description.substring(0, maxLength) + '...';
        }
        return description;
    }

    return (<>

            <div onClick={handleClick} >
            {/* <div className={projected_qty == 0 ? classes.itemCardDisabled : classes.itemCardEnabled} onClick={handleClick} > */}
                <div className='Item'>
                    <div src={cover} className={'Img'} style={{
                        backgroundImage: `url(${cover})`
                    }}></div>
                    <div className={'MainDetails'} >
                        <div className={'Name'} >{name}</div>
                        <div className="Description">{truncateDescription(description, 100)}</div>
                        <div className={'SubDetails'}>
                            <div className={'Price'} >{rate}</div>
                        </div>
                    </div>
                </div>

            </div>

            <MenuItemDetailsDialog onClose={handleClose} item={item} open={detailOpen}></MenuItemDetailsDialog>
        </>
    );
}
